import { alpha, Box, Stack, useTheme } from "@mui/material";
import { getColor } from "~/lib/colors";
import { ScoreRating } from "~/operations";

export default function WorkflowRiskDots({
  riskRating,
}: {
  riskRating: ScoreRating;
}) {
  let theme = useTheme();
  if (!riskRating) {
    return null;
  }
  const scoreMap: Record<string, number> = {
    critical: 5,
    high: 4,
    medium: 3,
    low: 2,
    info: 1,
  };

  const score = scoreMap[riskRating.toLowerCase()] || 0;
  const color = getColor(theme, riskRating);

  return (
    <Stack
      direction="row"
      sx={{
        py: 0,
        gap: 0.25,
      }}
    >
      {Array.from({ length: 5 }).map((_k, i) => (
        <Box
          key={i}
          sx={{
            height: 8,
            width: 8,
            borderRadius: 24,
            borderWidth: 1,
            borderStyle: "solid",
            borderColor: i < score ? color : theme.palette.background["tint-2"],
            background: i < score ? alpha(color, 0.5) : "transparent",
          }}
        />
      ))}
    </Stack>
  );
}
